var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTypeIdData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    id: "svg3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontWeight: "bold",
      fontSize: "38.5636px",
      lineHeight: 0,
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "start",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      fill: "#000000",
      strokeWidth: 2.41021
    },
    x: -2.466732,
    y: 25.494635,
    id: "text3"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan3",
    x: -2.466732,
    y: 25.494635,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontFamily: "'Tw Cen MT'",
      InkscapeFontSpecification: "'Tw Cen MT'",
      strokeWidth: 2.41021
    }
  }, "ID")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeIdData);
export default __webpack_public_path__ + "static/media/icon_type_id_data.48aafc6eab69f4e6293ddf189a0f77e1.svg";
export { ForwardRef as ReactComponent };